"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;

var _react = _interopRequireDefault(require("react"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _list = require("./list.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var List = function List(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _list.useStyles)(props);

  var header = /*#__PURE__*/_react["default"].createElement("thead", {
    className: "".concat(classes.thead)
  }, props.content.headers.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      className: "".concat(classes.header),
      key: index
    }, item.name);
  }));

  var body = props.content.contents.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: index
    }, props.content.headers.map(function (header, counter) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(classes.row),
        key: counter
      }, item[header.rowName]);
    }));
  });
  return /*#__PURE__*/_react["default"].createElement("table", {
    className: "".concat(classes.table)
  }, header, /*#__PURE__*/_react["default"].createElement("tbody", null, body));
};

exports.List = List;